import { useEffect, useState } from "react";
import { ExternalLink, ImageOff } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

// Ubah link berbagi menjadi tautan gambar langsung bila memungkinkan
const urlGambar = (url) => {
  if (!url) return "";
  const drive = url.match(/drive\.google\.com\/file\/d\/([^/]+)/);
  if (drive) return `https://drive.google.com/thumbnail?id=${drive[1]}&sz=w1200`;
  return url;
};

export const KtpPreview = ({ nama, link, open, onOpenChange }) => {
  const [gagal, setGagal] = useState(false);

  useEffect(() => {
    if (open) setGagal(false);
  }, [open, link]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="ktp-preview-dialog" className="border-[#1e2536] bg-[#10141d] sm:max-w-xl">
        <DialogHeader>
          <DialogTitle className="text-white">Foto KTP — {nama}</DialogTitle>
        </DialogHeader>

        {gagal ? (
          <div
            data-testid="ktp-preview-fallback"
            className="flex flex-col items-center gap-3 rounded-lg border border-[#1e2536] bg-[#0d1119] px-6 py-10 text-center"
          >
            <ImageOff size={28} className="text-[#2b3550]" />
            <p className="text-sm text-white">Foto tidak bisa ditampilkan di sini</p>
            <p className="max-w-sm text-xs text-[#4d586f]">
              Link ini berupa halaman berbagi (mis. WPS/Drive), bukan file gambar langsung. Buka di
              tab baru, atau simpan link gambar langsung (berakhiran .jpg/.png) agar bisa tampil di
              popup.
            </p>
          </div>
        ) : (
          <div className="overflow-hidden rounded-lg border border-[#1e2536] bg-[#0d1119]">
            <img
              data-testid="ktp-preview-image"
              src={urlGambar(link)}
              alt={`KTP ${nama}`}
              onError={() => setGagal(true)}
              className="max-h-[60vh] w-full object-contain"
            />
          </div>
        )}

        <a
          data-testid="ktp-preview-open-tab"
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1.5 text-xs text-[#00d09c] underline-offset-2 transition-colors duration-200 hover:text-[#00e5ff] hover:underline"
        >
          <ExternalLink size={12} /> Buka di tab baru
        </a>
      </DialogContent>
    </Dialog>
  );
};
